<template>
    <div
        class="tw-my-8"
    >
        <Heading :title="'Wann möchtest Du ' + countryName + ' erleben?'" :size="3" />
        <select
            v-model="selectedYear"
            id="YearSelector"
            class="tw-w-full tw-bg-white tw-border-2 tw-border-red-500 tw-rounded-lg tw-p-2 tw-my-2 tw-mr-2"
        >
            <option value="">
                Wähle ein Jahr aus
            </option>
            <option v-for="year in years" :value="year">
                {{year}}
            </option>
        </select>
        <select
            v-model="selectedMonth"
            id="MonthSelector"
            class="tw-w-full tw-bg-white tw-border-2 tw-border-red-500 tw-rounded-lg tw-p-2 tw-mr-2"
        >
            <option value="">
                Wähle einen Monat aus
            </option>
            <option v-for="month in activeMonths" :value="month.value">
                {{month.name}}
            </option>
        </select>
    </div>
</template>

<script>

export default {
    name: "TimeSelector",
    props: {
        countryName: String,
        required: true,
    },
    data: () => ({
        years: [new Date().getFullYear(), new Date().getFullYear()+1, new Date().getFullYear()+2],
        months: [{value: 1, name:"Januar"}, {value: 2, name:"Februar"}, {value: 3, name:"März"}, {value: 4, name:"April"}, {value: 5, name:"Mai"}, {value: 6, name:"Juni"}, {value: 7, name:"Juli"}, {value: 8, name:"August"}, {value: 9, name:"September"}, {value: 10, name:"Oktober"}, {value: 11, name:"November"}, {value: 12, name:"Dezember"}],
        activeMonths: [],
        selectedYear: '',
        selectedMonth: '',
    }),
    created() {
        this.selectedYear = this.$store.getters['tour/travelData'].year;
        if(this.selectedYear === new Date().getFullYear()) {
            this.activeMonths = this.months.filter(month => month.value >= new Date().getMonth() + 1);
        } else {
            this.activeMonths = this.months;
        }
        // check if the month from store is within the active months
        if(this.selectedMonthValid) {
            this.selectedMonth = this.$store.getters['tour/travelData'].month;
        } else {
            this.$store.commit('tour/setMonth', '');
            this.selectedMonth = '';
        }
    },
    computed: {
        selectedMonthValid: function () {
            return this.activeMonths.find(month => month.value === this.$store.getters['tour/travelData'].month)
        },
    },
    watch: {
        selectedYear: function (val) {
            this.$store.commit('tour/setYear', parseInt(val));
            if(val === new Date().getFullYear()) {
                this.activeMonths = this.months.filter(month => month.value >= new Date().getMonth() + 1);
                if (!this.selectedMonthValid) {
                    this.selectedMonth = '';
                }
            } else {
                this.activeMonths = this.months;
            }
        },
        selectedMonth: function (val) {
            this.$store.commit('tour/setMonth', parseInt(val));
            this.$store.commit('tour/setFullMonthName', this.months[val-1].name);
        }
    },
}
</script>
